module.exports = __webpack_public_path__ + "static/trenton-8469bd4b959b78782776d29d8b0a8509.png";